<div
  *ngIf="
    (mkSideBar.show && selectedTab.id === 0 && !selectedBook) ||
    (selectedTab.id === 1 && selectedCylinder) ||
    (selectedTab.id === 2 && selectedMasterKey?.rck)
  "
  class="row tool-bar"
  [flex]="0"
>
  <div class="col padding all"></div>

  <div class="col" style="width: 100%">
    <div class="row flex-end">
      <ng-container
        *ngIf="
          (selectedTab.id === 0 && !selectedBook) ||
          (selectedTab.id === 1 && selectedCylinder) ||
          (selectedTab.id === 2 && selectedMasterKey?.rck)
        "
      >
        <ng-container>
          <button mat-icon-button [matMenuTriggerFor]="actions">
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #actions>
            <button mat-menu-item (click)="saveMatrix()">
              <mat-icon>save</mat-icon>
              <span *ngIf="selectedTab.id === 0">Save KBA/SOP</span>
              <span *ngIf="selectedTab.id !== 0">Save</span>
            </button>
          </mat-menu>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
